import { API_BASE_URL } from "../config";
import type { SsmParameter } from "../types";

export async function fetchSsmParameters(solution: string): Promise<SsmParameter[]> {
  const url = `${API_BASE_URL}/ssm/${encodeURIComponent(solution)}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`SSM lookup failed for '${solution}': ${response.status}`);
  }
  return response.json();
}
